export default {
  csvExport(arrData, fileName) {
    let csvContent = "";
    csvContent += [
      Object.keys(arrData[0]).join(";"),
      ...arrData.map(item => {
        let line = "";
        Object.values(item).forEach(field => {
          if (typeof field == "number") {
            // Antonio C
            // 30/07/2020
            field = "" + field;
            field = field.replace(",", ".");
            line = line + field + ";";
          } else if (typeof field == "string") {
            field = "" + field;
            field = field.replace(/(\r\n|\n|\r)/g, "\\n");
            line = line + '"' + field + '";';
          } else {
            field = "" + field;
            field = field.replace(/;/g, "£££");
            field = field.replace(/(\r\n|\n|\r)/g, "\\n");
            line = line + field + ";";
          }
        });
        return line.slice(0, -1);
      })
    ]
      .join("\n")
      .replace(/(^\[)|(\]$)/gm, "");

    const data = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", data);
    link.setAttribute("download", fileName);
    link.click();
  },
  csvExportWithHeader(arrData, fileName, Header) {
    let csvContent = "";
    csvContent += [
      Header.join(";"),
      ...arrData.map(item => {
        let line = "";
        Object.values(item).forEach(field => {
          if (typeof field == "number") {
            field = "" + field;
            field = field.replace(",", ".");
          } else {
            field = "" + field;
            field = field.replace(/;/g, "£££");
            field = field.replace(/(\r\n|\n|\r)/g, "\\n");
            line = line + field + ";";
          }
        });
        return line.slice(0, -1);
      })
    ]
      .join("\n")
      .replace(/(^\[)|(\]$)/gm, "");

    const data = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", data);
    link.setAttribute("download", fileName);
    link.click();
  },
  parseCSV(str, fields) {
    var lines = str.split(/\n/); // Otteniamo un array di righe
    var data = lines.slice(1, lines.length); // Eliminiamo le intestazioni CSV
    var items = [];
    var headerLine = lines[0].trim().split(";");
    var item;
    var i = 0;
    var j = 0;
    var bFound = false;

    for (i = 0; i < headerLine.length; ++i) {
      bFound = false;
      for (j = 0; j < fields.length; ++j) {
        if (fields[j].key != "modify" && fields[j].key != "delete") {
          if (headerLine[i].trim() == fields[j].key.trim()) {
            bFound = true;
            break;
          }
        }
      }
      if (!bFound) {
        return null;
      }
    }

    var dataType = "";

    for (i = 0; i < data.length; ++i) {
      if (data[i].trim() != "") {
        var line = data[i];
        var parts = line.split(";"); // Otteniamo un array di valori

        /*
          Excel nel file CSV aggiunge all'inzio e alla fine i caratteti '"' e
          sostituisce il carattere '"' con '""' nel corpo del testo
        */
        for (j = 0; j < parts.length; ++j) {
          let s = parts[j];

          if (s.length >= 2) {
            let char_begin = s.substring(0, 1);
            let char_end = s.substring(s.length - 1, s.length);

            if (char_begin === '"' && char_end === '"') {
              // alert(s);

              // '"' -> inizio + fine
              s = s.substring(1, s.length - 1);

              // '""' -> '"'
              var s1 = s;
              do {
                s = s1;
                s1 = s.replace('""', '"');
              } while (s1 != s);
              s = s1;
              parts[j] = s;

              // alert(parts[j]);
            }
          }
        }

        item = {};

        for (j = 0; j < parts.length; ++j) {
          if (parts.length != headerLine.length) {
            console.log("STOP!!!");
          }

          dataType = this.getDataType(fields, headerLine[j].trim());

          if (
            dataType == "System.String" ||
            dataType == "System.Boolean" ||
            dataType == "System.Date"
          ) {
            let field = parts[j];
            field = field.replace("£££", ";");
            field = field.replace("\\n", "\n");
            item[headerLine[j].trim()] = field;
          } else {
            item[headerLine[j].trim()] = parts[j].replace(",", ".");
          }
        }
      }

      items.push(item);
    }
    return items;
  },

  getDataType(fields, key) {
    for (var i = 0; i < fields.length; ++i) {
      if (fields[i].key == key) {
        return fields[i].type;
      }
    }
    return "";
  }
};
